import React, { useEffect } from 'react';
import { crmAPI } from '../server';
import LogoAncona from '../assets/img/LogoAncona.png';

type WelcomePageProps = {
  onActivate?: () => void;
};

const WelcomePage: React.FC<WelcomePageProps> = ({ onActivate }) => {

  const handleTelefonoDetectado = (telefono: string) => {
    let data = {
      PhoneNumber:telefono,
      Accept:true
    }
    crmAPI.saveRequestFromUrl(data).then(() => {
            
    })
    .catch((err) => {
      console.log(err)
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const telefono = (params.get('phone') ?? '').replace(/\D/g, '');
    const storageKey = `phoneEnviado_${telefono}`;
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, '1');
    handleTelefonoDetectado(telefono);
  }, []);

  const handleActivate = () => {
    if (onActivate) {
      onActivate();
      return;
    }
  };

  return (
    <div className="bg-background text-on-background font-body-md">
      <header className="flex items-center w-full px-4 h-16 bg-surface border-b border-outline-variant fixed top-0 z-50 justify-center">
        <img 
          src={LogoAncona }
          alt="Ancona Pro Logo" 
          className="h-10 w-auto object-contain" 
        />
      </header>

      <main className="pt-24 pb-12 px-container-margin max-w-4xl mx-auto">
        <section className="mb-lg text-center md:text-left flex flex-col md:flex-row items-center gap-lg">
          <div className="flex-1">
            <h2 className="text-headline-md font-headline-md text-primary mb-md">
              ¡Hola! Somos Ancona Autopartes
            </h2>
            <p className="text-body-md font-body-md text-on-surface-variant max-w-2xl">
              Queremos agradecer tu preferencia y por eso hemos preparado para ti un beneficio
              exclusivo dentro de nuestro programa ANCONA PRO.
            </p>
          </div>
        </section>

        <section className="grid grid-cols-1 md:grid-cols-3 gap-md mb-md">
          <div className="md:col-span-2 bg-white rounded-xl p-lg border-t-4 border-secondary benefit-card-shadow flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-base mb-sm">
                <span className="material-symbols-outlined text-secondary text-headline-md">
                  military_tech
                </span>
                <h3 className="text-headline-md font-headline-md text-primary">
                  Beneficios exclusivos
                </h3>
              </div>
              <p className="text-on-surface-variant mb-lg">
                Acceso a promociones y herramientas diseñadas específicamente para optimizar la
                rentabilidad de tu taller.
              </p>
            </div>
          </div>
          <div className="space-y-md">
            <div className="bg-white rounded-xl p-md border-t-4 border-primary benefit-card-shadow flex items-center gap-md">
              <span className="material-symbols-outlined text-primary text-headline-sm">
                percent
              </span>
              <span className="font-label-bold text-label-bold text-primary">
                Descuentos especiales
              </span>
            </div>
            <div className="bg-white rounded-xl p-md border-t-4 border-primary benefit-card-shadow flex items-center gap-md">
              <span className="material-symbols-outlined text-primary text-headline-sm">
                support_agent
              </span>
              <span className="font-label-bold text-label-bold text-primary">
                Atención personalizada
              </span>
            </div>
            <div className="bg-white rounded-xl p-md border-t-4 border-primary benefit-card-shadow flex items-center gap-md">
              <span className="material-symbols-outlined text-primary text-headline-sm">
                query_stats
              </span>
              <span className="font-label-bold text-label-bold text-primary">
                Seguimiento comercial
              </span>
            </div>
          </div>
          <div className="md:col-span-3 bg-primary text-on-primary rounded-xl p-lg flex flex-col md:flex-row items-center justify-between gap-lg">
            <div className="flex items-center gap-md">
              <div className="p-base bg-secondary rounded-lg">
                <span className="material-symbols-outlined text-white text-headline-md">
                  workspace_premium
                </span>
              </div>
              <div>
                <h4 className="text-headline-md font-headline-md">Certificaciones y dinámicas</h4>
                <p className="text-primary-fixed opacity-90">
                  Eleva el nivel de tu taller con capacitaciones técnicas certificadas.
                </p>
              </div>
            </div>
            <div className="flex -space-x-4">
              <div className="w-12 h-12 rounded-full border-2 border-primary bg-surface-variant overflow-hidden">
                <img
                  alt="Mechanic 1"
                  className="w-full h-full object-cover"
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuCK2uF0l1O34FqZP1nqEQxSWoIQwMBV1iU0ugNxmP1t8PmuzAZ5sreQxiTfO7ndRszPwNOtvQUQAhRfle0V9QK857TP7PYoa69lHqdy7UFuddHFVTPJ6gSkYB9PATyJl_Mz0mCcy71h02sSXd1RChYOE3zsHkkbll_Mpi6WgFU5u0uXtOJKTRf_JKL6DuTmQKE7ZnqpCtWy1lrX0Oh5wsLsTCM2C6nFG5xyBW6clHbAyjOc5WP527NpfzClpChlToji9xLTVNJSQQ"
                />
              </div>
              <div className="w-12 h-12 rounded-full border-2 border-primary bg-surface-variant overflow-hidden">
                <img
                  alt="Mechanic 2"
                  className="w-full h-full object-cover"
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuBf3f2zL7eBJTgzQ4ToGhK00fZZkho7kekbkRsi52XZFO0hLZi8qu0ie9rsPSypLkXettDW2wDNWhBrm9q1-SaRElcPz5I3zYoIyYPv1kYDRqkDckLe2y4uCPtGqfs5okTL-OM1SrxeOKRDa_4mAtDzNzO_CxOaMt4G6Vk_i-5dgyPPjNxyFMrkHjG9ZlVEqFWMDGOCNln98Vm0-HWdOVT-_Ws2zQqgH7Mem4jAUJv0MYoIn5U3xsswSXRfx-qlc1F-tQiGwYdiuQ"
                />
              </div>
              <div className="w-12 h-12 rounded-full border-2 border-primary bg-surface-container flex items-center justify-center text-label-bold font-label-bold text-primary">
                +500
              </div>
            </div>
          </div>
        </section>

        <section className="flex flex-col items-center">
          <p className="mb-sm text-body-sm font-body-sm text-outline">
            Da clic en el siguiente enlace para activar tu beneficio
          </p>
          <button
            type="button"
            onClick={handleActivate}
            className="w-full py-4 bg-secondary text-white font-headline-md rounded-xl shadow-lg hover:bg-secondary-container transition-all active:scale-95 flex items-center justify-center gap-2"
          >
            ACTIVAR MI PLAN DE LEALTAD
            <span className="material-symbols-outlined">arrow_forward</span>
          </button>
        </section>
      </main>
    </div>
  );
};

export default WelcomePage;
